import React, { useEffect, useState } from "react";
import logo from "../../../images/logo_white1.png";
import "./host.css";
import { Link, useLocation } from "react-router-dom";
import { NavMenuToggle } from "../../layouts/nav/NavHader";

const navLinks = [
  {
    label: "Dashboard",
    icon: "bi bi-bar-chart-fill",
    to: "/host/dashboard",
  },
  {
    label: "Domes",
    icon: "bi bi-geo-alt-fill",
    to: (id) => `/host/${id}/dome`, // dynamic path
  },  
  {
    label: "Reports",
    icon: "bi bi-file-earmark-bar-graph-fill",
    to: "/host/reports",
  },
  {
    label: "Announcements",
    icon: "bi bi-megaphone-fill",
    to: "/host/announcements",
  },
  {
    label: "Host Account",
    icon: "bi bi-person-fill",
    to: (id) => `/host/${id}`, // dynamic path
  },

  

  // {
  //   label: "Invoices",
  //   icon: "bi bi-receipt-cutoff",
  //   to: "/host/invoices",
  // },
  {
    label: "Contact us",
    icon: "bi bi-telephone-fill",
    to: "/host/contact",
  },
];

const HostSidebar = () => {
  const location = useLocation();
  const [hostId, setHostId] = useState(null);

  useEffect(() => {
    // Read host details from localStorage
    const hostDetails = JSON.parse(localStorage.getItem("hostDetails"));
    if (hostDetails?._id) {
      setHostId(hostDetails._id);
    }
  }, []);

  const closeSidebarOnMobile = () => {
    if (window.innerWidth <= 991) {
      NavMenuToggle();
    }
  };

  return (
    <aside
      className="dlabnav-mobile host-login-bg d-flex flex-column align-items-start p-4"
      style={{
        minWidth: 260,
        maxWidth: 300,
        height: "100vh",
        background: "linear-gradient(135deg, #7B2D8E 0%, #C94FD4 50%, #FF1BE6 100%)",
        boxShadow: "4px 0 20px rgba(0,0,0,0.15)"
      }}
    >
      <div className="mb-5 w-100 text-center">
        <img
          src={logo}
          alt="somadome logo"
          style={{
            maxWidth: 200,
            width: "100%",
            filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.2))",
            transition: "transform 0.3s ease"
          }}
          className="mb-2"
          onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
          onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
        />
      </div>
      <nav className="flex-grow-1 w-100">
        {navLinks.map((link) => {
          const path =
            typeof link.to === "function" && hostId ? link.to(hostId) : link.to;
          const isActive = location.pathname === path;

          return (
            <Link
              key={link.label}
              to={path || "#"}
              className={`d-flex align-items-center mb-2 px-3 py-2 rounded-3 lato-medium-20 text-white sidebar-link ${isActive ? "sidebar-link-active" : ""
                }`}
              onClick={closeSidebarOnMobile}
              style={{
                background: isActive
                  ? "rgba(255, 27, 230, 0.9)"
                  : "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                border: isActive ? "1px solid rgba(255,255,255,0.3)" : "1px solid transparent",
                boxShadow: isActive
                  ? "0 4px 15px rgba(255, 27, 230, 0.4)"
                  : "none",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: isActive ? "translateX(5px)" : "translateX(0)"
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                  e.currentTarget.style.transform = "translateX(5px)";
                  e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.15)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                  e.currentTarget.style.transform = "translateX(0)";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              <i className={`${link.icon} me-3`} style={{ fontSize: 22 }}></i>
              <span>{link.label}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};

export default HostSidebar;
